// extracted by mini-css-extract-plugin
export var featureGrid = "ShortFeatureListMobile-module--feature-grid--16U8D";
export var row = "ShortFeatureListMobile-module--row--uxSi5";
export var rowFooter = "ShortFeatureListMobile-module--row-footer--AMabz ShortFeatureListMobile-module--row--uxSi5";
export var tier = "ShortFeatureListMobile-module--tier--1hYrL";
export var tierList = "ShortFeatureListMobile-module--tier-list--3jSPM";
export var tierHeader = "ShortFeatureListMobile-module--tier-header--37NUd";
export var tierTitle = "ShortFeatureListMobile-module--tier-title--rntx8";
export var featureButton = "ShortFeatureListMobile-module--feature-button--2Sp0r";
export var ctaUrl = "ShortFeatureListMobile-module--cta-url--26Dq8";
export var featureList = "ShortFeatureListMobile-module--feature-list--15PiL";
export var listHeading = "ShortFeatureListMobile-module--list-heading--3PkGo";
export var featureMark = "ShortFeatureListMobile-module--feature-mark--3HMtA";
export var featureTitle = "ShortFeatureListMobile-module--feature-title--20nEg";
export var tooltip = "ShortFeatureListMobile-module--tooltip--2W75w";
export var container = "ShortFeatureListMobile-module--container--5YK25";